import { FC } from 'react';
import { CarAllocation } from '../../../../../types/carAllocation';
import styles from './styles.module.css';
import TimeCellData from './TimeCellData';
import TimeCellDayOff from './TimeCellDayOff';

type Line = {
  title: string;
  days: Array<
    | {
        dayLabel: string;
        dayOff?: false;
        workStartTime: string;
        workEndTime: string;
        allocations: CarAllocation[];
      }
    | {
        dayLabel: string;
        dayOff: true;
      }
  >;
};
type Props = {
  line: Line;
  onClickDay?: (elem: HTMLElement, dayLabel: string) => void;
};
const AllocationTableRow: FC<Props> = ({ line, onClickDay }) => {
  return (
    <div className={styles.lineContainer}>
      <div className={styles.timelineGroupKeyCell}>
        <div className={styles.title}>{line.title}</div>
      </div>
      {line.days.map((line) => (
        <div className={styles.cell} key={line.dayLabel}>
          {line.dayOff ? (
            <TimeCellDayOff />
          ) : (
            <TimeCellData
              {...line}
              onClick={(elem) => onClickDay?.(elem, line.dayLabel)}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default AllocationTableRow;
